import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex gc-4" }, [
    _c(
      "a",
      { attrs: { href: _setup.doctorPageUrl } },
      [
        _c(VImg, {
          staticClass: "rounded-sm",
          attrs: {
            alt: _setup.t("Аватар", _setup.options),
            "lazy-src": "/static/_v1/pd/icons/ui-kit/photo/no-avatar.svg",
            src: _setup.getDoctorAvatarUrl({ doctor: _vm.doctor }),
            width: "100",
            height: "100",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex flex-column justify-center" },
      [
        _c(
          "a",
          {
            staticClass:
              "text-subtitle-1 text-decoration-none primary--text mb-1",
            attrs: { href: _setup.doctorPageUrl },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.transDynamic(
                    _vm.doctor,
                    `fio,${_setup.languageIso},${_setup.needTranslate}`
                  )
                ) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _setup.context.request.feature_flags?.ff_redesign_rating &&
        _vm.doctor.stars
          ? _c(_setup.RatingRow, {
              staticClass: "mb-2",
              attrs: {
                solidity: _vm.doctor.stars,
                "reviews-count": _vm.doctor.rates ?? 0,
                "reviews-href": `${_setup.doctorPageUrl}#otzivi`,
              },
            })
          : _c(_setup.StarsRate, {
              staticClass: "mb-2",
              attrs: { solidity: _vm.doctor.stars },
            }),
        _vm._v(" "),
        _c("span", { staticClass: "text-body-2" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _setup.transDynamic(
                  _vm.doctor.town,
                  `name,${_setup.languageIso},${_setup.needTranslate}`
                )
              ) +
              "\n    "
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }